app.ui.registerUi('btn', function(app) {
	var helpers = app.helpers.funcs;
	return {

		implementationExists: function() {
			return jQuery.fn.button ? true : false;
		},

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

		init: function($scope) {

			var $btns = helpers.resolveScope('.btn', $scope);
			this.initBootstrap($btns);
			this.initStateListeners($btns);
			this.adjustSizeClasses($btns);
            this.addGerListeners($btns);

            var $glyphs = helpers.resolveScope('.link-glyph', $scope);
            this.initStateListenersForLinkGlyphs($glyphs);
		},

		initBootstrap: function($btns) {
			if (!this.implementationExists()) return;
			$btns.button();
			$btns.each(function (k, btn) {
			    var $input = $(btn).find('input');
			    if ($input.attr('checked')) {
			        $(btn).addClass('active');
			    }
			});
		},

		initStateListenersForLinkGlyphs: function($btns) {
			$btns.each(function(k, btn) {
                var t;
                var d = new Date();
				var $btn = $(btn);
                $btn.mouseenter(function () {
                    var d2 = new Date();
                    var diff = d2.getTime() - d.getTime();
                    if (diff > 500) {
                        $btn.addClass('hovered');
                        t = setTimeout(function () {
                            $btn.removeClass('hovered');
                        }, 500);
                    }
                    d = new Date();
				});
			});
		},


		initStateListeners: function($btns) {
			var t;
			$btns.each(function(k, btn) {
				var $btn = $(btn);
				$btn.click(function() {
					if (!$btn.hasClass('clicked')) {
						$btn.addClass('clicked');
						setTimeout(function() {
							$btn.removeClass('clicked');
						}, 300);
					}
				});
				$btn.mouseout(function() {
					clearTimeout(t);
					$btn.removeClass('hovered').addClass('hovered');
					t = setTimeout(function() {
						$btn.removeClass('hovered');
					}, 400);
				});
			});
		},

		adjustSizeClasses: function($btns) {
			$btns.each(function(k, btnElem) {
				var $btnElem = $(btnElem);
				var w = $btnElem.width();
				$btnElem.removeClass('detected-wide-btn')
				$btnElem.removeClass('detected-super-wide-btn')
				if (w > 450) {
				    if (w > 600) {
				        $btnElem.addClass('detected-super-wide-btn');
				    } else {
				        $btnElem.addClass('detected-wide-btn');
				    }
				}
			});
		},
		
		addGerListeners: function($btns) {
			var scope = this;
			app.globalEventRegistry.addListener('resize', function() {
				scope.adjustSizeClasses($btns);
			});
		}
	};
});
